import { render, staticRenderFns } from "./CustomerServices.vue?vue&type=template&id=54c94946&scoped=true"
import script from "./CustomerServices.vue?vue&type=script&lang=js"
export * from "./CustomerServices.vue?vue&type=script&lang=js"
import style0 from "./CustomerServices.vue?vue&type=style&index=0&id=54c94946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c94946",
  null
  
)

export default component.exports